import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-edfeebfa")

_pushScopeId("data-v-edfeebfa")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "cleanText" }
const _hoisted_3 = { class: "kn-page-content" }
const _hoisted_4 = { class: "managerDetail p-grid p-m-0 kn-height-full" }
const _hoisted_5 = { class: "p-col" }
const _hoisted_6 = { class: "p-grid p-pt-0" }
const _hoisted_7 = { class: "p-col-10" }
const _hoisted_8 = { class: "p-input-icon-left p-col p-p-0" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "p-col p-d-flex p-jc-end p-ai-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_ResourceManagementImportFileDialog = _resolveComponent("ResourceManagementImportFileDialog")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withId(() => [
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.folder.label), 1)
      ]),
      end: _withId(() => [
        _withDirectives(_createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDetail()))
        }, null, 512), [
          [
            _directive_tooltip,
            _ctx.$t('common.close'),
            void 0,
            { bottom: true }
          ]
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Breadcrumb, {
      home: _ctx.home,
      model: _ctx.items
    }, null, 8, ["home", "model"]),
    _createVNode("div", _hoisted_3, [
      (_ctx.selectedFiles.length > 0)
        ? (_openBlock(), _createBlock(_component_Toolbar, {
            key: 0,
            class: "kn-toolbar kn-toolbar--default p-m-0"
          }, {
            start: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc('managers.resourceManagement.selectedFiles', _ctx.selectedFiles.length, { num: _ctx.selectedFiles.length })), 1)
            ]),
            end: _withId(() => [
              _createVNode(_component_Button, {
                icon: "fas fa-download",
                class: "p-button-text p-button-rounded p-button-plain kn-button-light",
                onClick: _ctx.downloadFiles
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "fas fa-trash",
                class: "p-button-text p-button-rounded p-button-plain kn-button-light",
                onClick: _ctx.showDeleteDialog
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ResourceManagementImportFileDialog, {
        visibility: _ctx.importFile,
        "onUpdate:visibility": _cache[2] || (_cache[2] = ($event: any) => (_ctx.importFile = $event)),
        path: _ctx.folder.key,
        onFileUploaded: _ctx.fileUploaded,
        existingFiles: _ctx.files
      }, null, 8, ["visibility", "path", "onFileUploaded", "existingFiles"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataTable, {
            ref: "dt",
            value: _ctx.files,
            loading: _ctx.loading,
            selection: _ctx.selectedFiles,
            "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedFiles = $event)),
            filters: _ctx.filters,
            "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = $event)),
            class: "p-datatable-sm kn-table",
            paginator: true,
            rows: 10,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            rowsPerPageOptions: [10, 15, 20],
            responsiveLayout: "stack",
            breakpoint: "960px",
            currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' }),
            globalFilterFields: ['name', 'type', 'tags']
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      type: "text",
                      modelValue: _ctx.filters['global'].value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters['global'].value = $event)),
                      placeholder: _ctx.$t('common.search'),
                      badge: "0"
                    }, null, 8, ["modelValue", "placeholder"])
                  ])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_Button, {
                    icon: "fas fa-sync-alt",
                    class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadSelectedFolder())),
                    disabled: _ctx.selectedFiles.length > 0
                  }, null, 8, ["disabled"]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-upload",
                    class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0",
                    onClick: _ctx.openImportFileDialog,
                    disabled: _ctx.selectedFiles.length > 0
                  }, null, 8, ["onClick", "disabled"])
                ])
              ])
            ]),
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            loading: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
            ]),
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getOrderedColumns(), (col) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  field: col.field,
                  header: _ctx.$t(col.header),
                  class: "kn-truncated",
                  key: col.position,
                  style: col.style,
                  selectionMode: col.field == 'selectionMode' ? 'multiple' : '',
                  exportable: col.field == 'selectionMode' ? false : ''
                }, _createSlots({ _: 2 }, [
                  (col.field != 'selectionMode')
                    ? {
                        name: "body",
                        fn: _withId(({data}) => [
                          (col.displayType == 'fileSize')
                            ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.getDataValue(data.size)), 1))
                            : (col.displayType == 'date')
                              ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.getDate(data.lastModified)), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_13, [
                                  _createVNode("span", {
                                    class: "kn-truncated",
                                    title: data[col.field]
                                  }, _toDisplayString(data[col.field]), 9, ["title"])
                                ]))
                        ])
                      }
                    : undefined
                ]), 1032, ["field", "header", "style", "selectionMode", "exportable"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "loading", "selection", "filters", "currentPageReportTemplate"])
        ])
      ])
    ])
  ]))
})